module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "student-list"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.$t("MANAGESTUDENTS")))]), _vm._v(" "), (_vm.selectedStudents.length != 0) ? _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "close"
    },
    on: {
      "click": function($event) {
        _vm.selectedStudents = []
      }
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.printCard
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t("PRINTCARDS")) + " ("), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.selectedStudents.length)
    }
  }), _vm._v(")")])], 1) : _c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "dark"
    },
    on: {
      "command": _vm.handleClick
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "disabled": !_vm.isAllowed('save')
    },
    on: {
      "click": _vm.newStudent
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('ADDNEWSTUDENT')) + "\n                ")]), _vm._v(" "), _c('el-button', {
    ref: "trigger",
    staticClass: "el-dropdown__caret-button"
  }, [_c('i', {
    staticClass: "el-dropdown__icon el-icon-caret-bottom"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown",
      "id": "student"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('import')
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".csv",
      "action": _vm.URL + 'media/upload',
      "data": _vm.import_data,
      "with-credentials": true,
      "headers": {
        'Accept-Language': _vm.currentLang(),
        'X-API-KEY': _vm.API_KEY
      },
      "on-success": _vm.uploadedFile
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t("UPLOADCSVFILE")) + "\n              ")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "print"
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t("PRINTALLCARDS")))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": !_vm.isAllowed('save_tag'),
      "command": "tag"
    }
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" " + _vm._s(_vm.$t("CHECKTAGID")))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "filter",
    staticClass: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('CHOOSEFILERBY')
    },
    on: {
      "change": _vm.changedFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return (item.value != _vm.active_filter) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), (_vm.active_filter == 'name') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHSTUDENTNAME'),
      "icon": _vm.FullName ? 'circle-close' : ''
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      },
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.FullName),
      callback: function($$v) {
        _vm.FullName = $$v
      },
      expression: "FullName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'id') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('SEARCHSTUDENTID'),
      "icon": _vm.ExternalStudentID ? 'circle-close' : ''
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      },
      "click": _vm.clearInput
    },
    model: {
      value: (_vm.ExternalStudentID),
      callback: function($$v) {
        _vm.ExternalStudentID = $$v
      },
      expression: "ExternalStudentID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'route') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYROUTE'),
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.RouteID),
      callback: function($$v) {
        _vm.RouteID = $$v
      },
      expression: "RouteID"
    }
  }, _vm._l((_vm.routes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.TourName,
        "value": item.TourID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'grade') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "value-key": "GradeID",
      "placeholder": _vm.$t('FILTERBYGRADE'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.Grade),
      callback: function($$v) {
        _vm.Grade = $$v
      },
      expression: "Grade"
    }
  }, _vm._l((_vm.grades), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.Grade.Classes != undefined && _vm.active_filter == 'grade') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYCLASS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.gradeClass),
      callback: function($$v) {
        _vm.gradeClass = $$v
      },
      expression: "gradeClass"
    }
  }, _vm._l((_vm.Grade.Classes), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.active_filter == 'status') ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": _vm.$t('FILTERBYSTATUS'),
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.getStudents(true)
      }
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('ACTIVE'),
      "value": "1"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ACTIVE')))])], 1), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('INACTIVE'),
      "value": "2"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "danger",
      "close-transition": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('INACTIVE')))])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.new_page || _vm.loading),
      expression: "new_page || loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "data": _vm.listStudents,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    staticClass: "center",
    attrs: {
      "prop": "ExternalStudentID",
      "label": _vm.$t('STUDENTID'),
      "min-width": "150",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('NAME'),
      "min-width": "200",
      "prop": "FullName_EN",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath),
            "alt": ""
          }
        }), _vm._v("\n                " + _vm._s(_vm._FullName({
          NameEN: scope.row.FullName_EN,
          NameAR: scope.row.FullName_AR
        })) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Grade",
      "label": _vm.$t('GRADE'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Class",
      "label": _vm.$t('CLASS'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Status",
      "label": _vm.$t('STATUS'),
      "min-width": "100",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": parseInt(scope.row.Status) !== 1 ? 'success' : 'danger',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(parseInt(scope.row.Status) !== 1 ? _vm.$t('ACTIVE') : _vm.$t('INACTIVE')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AssignmentStatus",
      "label": _vm.$t('ASSIGNEDTOBUS'),
      "min-width": "160",
      "align": "center",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(scope.row.AssignmentStatus !== null ? _vm.$t('ASSIGNED') : _vm.$t('NOTASSIGNED')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": _vm.isOnQueue(scope.row) ? 'primary' : ''
          },
          on: {
            "click": function($event) {
              _vm.printQueue(scope.row)
            }
          }
        }, [_c('i', {
          class: [_vm.isOnQueue(scope.row) ? 'fa fa-check-square' : 'fa fa-square-o']
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.IDCard(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-id-card"
        }), _vm._v(" " + _vm._s(_vm.$t('IDCARD')))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "actions",
    attrs: {
      "label": "",
      "min-width": "220",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isAllowed('save', 'attendance/absence')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('MARKABSENCE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.markAbsence(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user-times"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('send', 'report/message')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('SENDMESSAGE'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showMessageModal(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-comment"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save_tag')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('ISSUEATTENDANCETAG'),
            "placement": "top"
          }
        }, [_c('el-button', {
          class: [scope.row.AssignedTagID != null ? 'text-success' : ''],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showScanModal(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-wifi"
        })])], 1) : _vm._e(), _vm._v(" "), (_vm.isAllowed('save')) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('EDITSTUDENT'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.$router.push({
                path: '/school/student/' + scope.row.StudentID
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "disabled": scope.row.AssignmentStatus != null ? true : false,
            "content": _vm.listStudents[scope.$index].Status == 0 ? _vm.$t('DEACTIVATESTUDENT') : _vm.$t('ACTIVATESTUDENT'),
            "placement": "top"
          }
        }, [_c('el-popover', {
          attrs: {
            "trigger": "manual",
            "placement": "left",
            "width": "160"
          },
          on: {
            "show": function($event) {
              _vm.student = _vm.listStudents[scope.$index]
            }
          },
          model: {
            value: (_vm.listStudents[scope.$index].Deleted),
            callback: function($$v) {
              _vm.$set(_vm.listStudents[scope.$index], "Deleted", $$v)
            },
            expression: "listStudents[scope.$index].Deleted"
          }
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('AREYOUSUREYOUWANTTO') + ' ') + _vm._s(_vm.listStudents[scope.$index].Status == 0 ? _vm.$t('DEACTIVATETHISSTUDENT') : _vm.$t('RESTORETHISSTUDENT')))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "text-align": "right",
            "margin": "0"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.listStudents[scope.$index].Deleted = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toggleStatus(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('CONFIRM')))])], 1), _vm._v(" "), (_vm.isAllowed('delete')) ? _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "slot": "reference",
            "disabled": scope.row.AssignmentStatus != null,
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.checkRoute(scope.$index)
            }
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "fa",
          class: [scope.row.DeletedAT != null ? 'fa-undo' : 'fa-times']
        })]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalStudents
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-tag-dialog', {
    attrs: {
      "callScan": _vm.callScan,
      "findTag": _vm.findTag,
      "student": _vm.student
    },
    on: {
      "update:callScan": function($event) {
        _vm.callScan = $event
      }
    }
  }), _vm._v(" "), _c('el-absence-dialog', {
    attrs: {
      "data": _vm.absence,
      "selected-student": _vm.absenceStudent,
      "server-check": true,
      "visible": _vm.absenceBox
    },
    on: {
      "update:visible": function($event) {
        _vm.absenceBox = $event
      }
    }
  }), _vm._v(" "), _c('el-message-dialog', {
    attrs: {
      "visible": _vm.messageBox,
      "showRemove": false,
      "studentList": _vm.messageStudent,
      "parent": _vm.parent
    },
    on: {
      "update:visible": function($event) {
        _vm.messageBox = $event
      }
    }
  }), _vm._v(" "), _c('el-import-dialog', {
    attrs: {
      "visible": _vm.dialogImport,
      "fields": _vm.fields,
      "title": _vm.$t('STUDENTS'),
      "uri": "student/import",
      "CSVReader": _vm.CSVReader,
      "CSVFile": _vm.CSVFile
    },
    on: {
      "reCall": _vm.getStudents,
      "update:visible": function($event) {
        _vm.dialogImport = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": _vm.$t('STUDENTIDCARD'),
      "visible": _vm.dialogVisible,
      "before-close": _vm.handleDialogClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    ref: "printCard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.selectedStudents), function(item, index) {
    return _c('el-col', {
      key: index,
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "span": _vm.printCardWidth
      }
    }, [_c('el-row', {
      staticStyle: {
        "background-color": "#f5c838!important"
      },
      attrs: {
        "type": "flex"
      }
    }, [_c('el-col', {
      staticClass: "card-pic",
      attrs: {
        "span": 6
      }
    }, [_c('img', {
      staticClass: "img-circle pic",
      attrs: {
        "src": _vm.getAsset(item.ImagePath)
      }
    }), _c('br'), _c('br'), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "60%",
        "margin-bottom": "5px"
      },
      attrs: {
        "src": _vm.getAsset(_vm.school.school_logo === 'no-school.png' ? 'adec-print-logo.png' : _vm.school.school_logo, 'configuration')
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.school.school_name))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }, [_c('el-form', {
      staticStyle: {
        "margin": "15px"
      },
      attrs: {
        "label-position": "top"
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('FIRSTNAME')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": _vm._FullName({
          NameEN: item.FirstName_EN,
          NameAR: item.FirstName_AR
        }),
        "readonly": ""
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('LASTNAME')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": _vm._FullName({
          NameEN: item.LastName_EN,
          NameAR: item.LastName_AR
        }),
        "readonly": ""
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('SCHOOLCONTACT')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": _vm.school.contact_number,
        "readonly": ""
      }
    })], 1), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('GRADE')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.Grade,
        "readonly": ""
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('CLASS')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.Class,
        "readonly": ""
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('STUDENTID')
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.ExternalStudentID,
        "readonly": ""
      }
    })], 1)], 1)], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.printCard
    }
  }, [_vm._v(_vm._s(_vm.$t('PRINT')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fdbbb5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/school/Student.vue
// module id = 604
// module chunks = 1